'use strict';

import BamLinker from './lib/BamLinker';

export default BamLinker;

